export const ASHBY_APPLICATION_TEXTS = {
    fallbackUnavailable: "Application form is currently unavailable. Please try again later.",
    success: {
        heading: "Application submitted!",
        body: "Thank you for applying. We will review your application and get back to you."
    },
    autofill: {
        heading: "Autofill from Resume",
        subheading: "Upload your resume to automatically fill in your application details",
        chooseFile: "Choose Resume File",
        parsing: "Parsing resume...",
        statusSuccess: "Resume uploaded! Please review and complete your information below.",
        statusError: "Resume uploaded! Please fill in your information manually."
    },
    form: {
        selectPlaceholder: "Select...",
        resumeChangeButton: "Change",
        requiredError: "This field is required",
        submitIdle: "Apply to this job",
        submitInProgress: "Submitting...",
        privacyNotice: "Please review our privacy practices:",
        privacyLinkText: "Privacy policy: monday.com"
    }
};
